import Vue from 'vue';
import VueCookies from 'vue-cookies';

// Registro de Cookies
Vue.use(VueCookies);
export const state = {
    supplierList: [],
    tag: {},
    form: {},
    questions: {},
    competitionId: '',
    magicLink: ''
};
export const mutations = {
    PUSH_SUPPLIER(state, supplier) {
        state.supplierList.push(supplier);
    },
    REMOVE_SUPPLIER(state, index) {
        state.supplierList.splice(index, 1);
    },
    REMOVE_SUPPLIER_WITH_SUPPLIER(state, supplier) {
        state.supplierList.splice(state.supplierList.indexOf(supplier), 1);
    },
    CLEAR_SUPPLIERS(state) {
        state.supplierList = [];
    },
    SELECT_TAG(state, tag) {
        state.tag = tag;
    },
    FORM_ADD_DATA(state, data) {
        state.form = { ...state.form, ...data };
    },
    QUESTIONS_ADD_DATA(state, data) {
        state.questions = { ...state.questions, ...data };
    },
    SAVE_COMPETITION_ID(state, id) {
        state.competitionId = id;
    },
    SAVE_MAGIC_LINK(state, url) {
        state.magicLink = url;
    }
};
export const actions = {
    pushSupplier({ commit }, supplier) {
        commit('PUSH_SUPPLIER', supplier);
    },
    removeSupplier({ commit }, supplierList) {
        commit('REMOVE_SUPPLIER', supplierList);
    },
    removeSupplierWithSupplier({ commit }, supplier) {
        commit('REMOVE_SUPPLIER_WITH_SUPPLIER', supplier);
    },
    clearSuppliers({ commit }) {
        commit('CLEAR_SUPPLIERS');
    },
    selectTag({ commit }, tag) {
        commit('SELECT_TAG', tag);
    },
    formAddAtributes({ commit }, data) {
        commit('FORM_ADD_DATA', data);
    },
    questionsAddAtributes({ commit }, data) {
        commit('QUESTIONS_ADD_DATA', data);
    },
    saveCompetitionId({ commit }, id) {
        commit('SAVE_COMPETITION_ID', id);
    },
    saveMagicLink({ commit }, id) {
        commit('SAVE_MAGIC_LINK', id);
    }
};
